import { html } from 'lit-html';
import { RrAreaLeftSide } from '../../../../core/views/pc/rr_item/rr_area_left_side';
import { RrAreaNormal } from '../../../../core/views/pc/rr_item/rr_area_normal';
import { CategoryMJsEnv } from '../../models/category_m_js_env';

//メーカー・ブランド
export const RrBodyNormalLower = (model: CategoryMJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileNormalLower, model.isLogin)}
`;

export const RrBodyNormalUpper = (model: CategoryMJsEnv) => html`
${RrAreaNormal(model.rrAreaProfileNormalUpper, model.isLogin)}
`;
export const RrBodyLeftSide = (model: CategoryMJsEnv) => html`
${RrAreaLeftSide(model.rrAreaProfileLeftSide, model.isLogin)}
`;
